import React, { createContext, useContext, useState, useEffect } from 'react';
import { collection, onSnapshot, query, limit } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useLanguage } from './LanguageContext';

const LiveEventsContext = createContext();

export const useLiveEvents = () => useContext(LiveEventsContext);

export const LiveEventsProvider = ({ children }) => {
    const { t } = useLanguage();
    const [liveEvents, setLiveEvents] = useState([]);
    const [activeSport, setActiveSport] = useState('all');

    useEffect(() => {
        // Refactorización de Escalabilidad: Escuchar la colección 'live_events'
        // Esto elimina el cuello de botella del límite de 1MB por documento.
        // Refactorización de Escalabilidad: Escuchar la colección 'public/live_feed/live_feed'
        // Esto se alinea con la estructura verificada en la base de datos del usuario.
        const eventsRef = collection(db, 'public', 'live_feed', 'live_feed');
        // Opcional: Podríamos agregar query(eventsRef, where('sportId', '==', ...)) si quisiéramos filtrar en servidor.

        const unsubscribe = onSnapshot(eventsRef, (snapshot) => {
            const events = [];
            snapshot.forEach((doc) => {
                events.push(doc.data());
            });
            setLiveEvents(events);
        }, (error) => {
            console.error("Error escuchando Live Feed (Collection):", error);
        });

        return () => unsubscribe();
    }, []);

    // Mantener la función fetchLive vacía o como fallback si se desea, 
    // pero para este objetivo la reemplazamos por el listener.
    const fetchLive = () => { };


    return (
        <LiveEventsContext.Provider value={{ liveEvents, activeSport, setActiveSport, fetchLive }}>
            {children}
        </LiveEventsContext.Provider>
    );
};
